// Shared by the development build and browser startup. This prevents mistakes;
// database authorization remains a separate server-side responsibility.
function assertLocalEnvironment(url, key) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    throw new Error(
      'Local Supabase URL is missing or invalid. Run npm run local:setup.',
    );
  }
  if (
    parsed.protocol !== 'http:' ||
    !['127.0.0.1', 'localhost'].includes(parsed.hostname) ||
    parsed.port !== '54321' ||
    parsed.username ||
    parsed.password ||
    parsed.search ||
    parsed.hash ||
    parsed.pathname !== '/'
  ) {
    throw new Error(
      'Development only accepts http://127.0.0.1:54321 or http://localhost:54321. Remote databases are blocked.',
    );
  }
  if (!key)
    throw new Error('Local public key is missing. Run npm run local:setup.');
  if (key.startsWith('sb_secret_'))
    throw new Error('A secret key cannot be used in the browser.');
  if (!key.startsWith('sb_publishable_')) {
    try {
      const payload = JSON.parse(
        atob(key.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
      );
      if (payload.role !== 'anon') throw new Error('not public');
    } catch {
      throw new Error(
        'Local browser configuration requires an anon/public key, never a service-role key.',
      );
    }
  }
}
function assertProductionDataEnvironment(url, key) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    throw new Error(
      'Production-data Supabase URL is missing or invalid. Check .env.production-data.local.',
    );
  }
  const hostname = parsed.hostname
    .toLowerCase()
    .replace(/^\[|\]$/g, '')
    .replace(/\.$/, '');
  if (
    parsed.protocol !== 'https:' ||
    hostname.startsWith('127.') ||
    ['0.0.0.0', '::1', 'localhost'].includes(hostname) ||
    hostname.endsWith('.localhost') ||
    parsed.username ||
    parsed.password ||
    parsed.search ||
    parsed.hash ||
    parsed.pathname !== '/'
  ) {
    throw new Error(
      'Production-data mode requires a remote HTTPS Supabase URL without credentials, path, query, or fragment.',
    );
  }
  if (!key)
    throw new Error(
      'Supabase public key is missing from .env.production-data.local.',
    );
  if (key.startsWith('sb_secret_'))
    throw new Error('A secret key cannot be used in the browser.');
  if (!key.startsWith('sb_publishable_')) {
    try {
      const payload = JSON.parse(
        atob(key.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
      );
      if (payload.role !== 'anon') throw new Error('not public');
    } catch {
      throw new Error(
        'Production-data mode requires an anon/public key, never a service-role key.',
      );
    }
  }
}
module.exports = { assertLocalEnvironment, assertProductionDataEnvironment };
